import { ClientService } from '@/services/client';
import { DeliveryService } from '@/services/delivery';
import { NavigatorService } from '@/services/navigator';
import { SERVICES } from '@/utils/constants';
import { computed } from 'vue';

const useDeliveryAddress = () => {
	const activeTown = computed(() => {
		const towns = NavigatorService.state.towns;
		return (
			towns.find(
				town => town.name === DeliveryService.state.tempAddress.city
			) || towns[0]
		);
	});

	const activeAddress = computed(() => DeliveryService.state.activeAddress);

	const activeAddressCoordinates = computed(() => {
		if (DeliveryService.hasAvailableAddress()) {
			return DeliveryService.state.activeAddress.coordinates;
		}

		return ClientService.state.coordinates || activeTown.value.coordinates;
	});

	const getRelevantCoordinates = () => {
		if (ClientService.state.service.id === SERVICES.delivery.id) {
			return activeAddressCoordinates.value;
		}

		return ClientService.state.coordinates;
	};

	return {
		activeTown,
		activeAddress,
		activeAddressCoordinates,
		getRelevantCoordinates
	};
};

export default useDeliveryAddress;
